import { ILegalDocument } from "../../../models/response/legal-document/ILegalDocument";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eLegalDocumentDefine = {
    LOAD_START: undefined,
    LOAD_SUCCESS: [] as ILegalDocument[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as ILegalDocument | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as ILegalDocument,
    SAVE_SUCESSS: {} as ILegalDocument,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCESSS: {} as ILegalDocument,
    DELETE_ERROR: "",
}
export const eLegalDocuemntActionTypeIds = generateActionTypeIds(eLegalDocumentDefine, "LEGAL_DOCUMENT")
export type ILegalDocumentActionTypes = IGenericActionType<typeof eLegalDocumentDefine, "LEGAL_DOCUMENT">